import { przezmorzeApi, throwMessageOnStatuses } from "../../api/api";

export async function reassignIncomingTransfer(txId: string, userFriendlyOrderId: number): Promise<void> {
  try {
    await przezmorzeApi.post<unknown>(`/bank-connect/reassign`, { txId, userFriendlyOrderId });
  } catch (error) {
    throwMessageOnStatuses(error, [404, 409]);
  }
}
